import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { EventosService } from 'src/app/services/eventos.service';
import { SalesCountdown, SalesCountdownService } from 'src/app/services/sales-countdown.service';
import { BondsServices } from 'src/app/services/bonds.service';
import { TicketsService } from 'src/app/services/tickets.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { PrivateEventComponent } from '../private-event/private-event.component';
import { TicketsBondComponent } from '../tickets-bond/tickets-bond.component';
import { PassSelectDialogComponent } from '../../passes/pass-select-dialog/pass-select-dialog.component';
import { PassPurchaseComponent } from '../../passes/pass-purchase/pass-purchase.component';
import { passUnavailableMessage } from 'src/app/utils/pass-availability.util';

@Component({
  selector: 'app-open-external',
  templateUrl: './open-external.component.html',
  styleUrls: ['./open-external.component.scss']
})
export class OpenExternalComponent implements OnInit, OnDestroy {

  @Input() event!: any;
  @Input() pastEvent!: boolean;
  @Input() repeat: any;
  @Output() openHours: EventEmitter<boolean> = new EventEmitter();
  /** Abrir directamente el mapa de la única sesión del evento; lleva la sesión */
  @Output() openMap: EventEmitter<any> = new EventEmitter();
  /** El mapa pedido con openMap se está cargando */
  @Input() openingMap: boolean = false;
  disabledSales: boolean = true;
  endSales: boolean = false;
  enableAbono: boolean = false;
  optionsHour: any[] = [];
  
  viewTotem: boolean = AppSettings.ENV_TOTEM;
  
  endedEvent: boolean = false;
  sessionsEnabled: any[] = [];
  today: Date = new Date();
  sameHoursForAllDates: boolean = true;

  /** Momento en el que abre la venta, solo mientras siga cerrada */
  salesOpenDate: Date | null = null;
  /** «Vie 12 oct · 10:00», o «Hoy»/«Mañana» cuando toca */
  salesOpenLabel: string = '';
  /** Cuenta atrás hasta la apertura; null en cuanto la venta abre */
  countdown: SalesCountdown | null = null;
  private countdownSubscription: Subscription | null = null;

  constructor(
    private eventosService: EventosService,
    private dialog: MatDialog,
    private router: Router,
    private ticketsService: TicketsService,
    private bondsService: BondsServices,
    private renderer: Renderer2,
    private salesCountdown: SalesCountdownService,
    @Inject(LOCALE_ID) private locale: string
  ) {
  }

 get displayFromPrice(): number {
    return this.event?.custom_from_price ?? this.event?.from_price;
  }

  /**
   * Con acción de compra el bloque se convierte en la barra fija de abajo
   * (ver el SCSS). Sin ella —evento informativo o tótem— se queda como un
   * bloque más de la ficha.
   */
  get hasActions(): boolean {
    return !this.event?.informative && !this.viewTotem;
  }

 ngOnInit(): void {
    // Check if event belongs to a pass-type discount via the new API
    this.checkEventHasAbono();
    let now = new Date();
    let nowHour = new Date();
    now.setHours(0);
    now.setMinutes(0);
    //para determinar si la venta esta habilitada debemos convertir la fecha de inicio de ventas a la hora local UTC+Correspondiente
    const eventDateUTC = new Date(this.event?.start_sales);
    //aca sumamos a la hora UTC 0 la diferencia de la zona horaria en milisegundos
    //const eventDateLocal = new Date(eventDateUTC.getTime() - eventDateUTC.getTimezoneOffset() * 60000);
    //console.log(eventDateLocal, eventDateUTC);
    this.disabledSales = this.event?.start_sales && (eventDateUTC > nowHour);
    const sessionsEvent = this.event.sessions.filter((session: any) => new Date(session.start_date) >= now);

    // Proxima sesión
    if (sessionsEvent.length > 0) {
      let firstSession = sessionsEvent.sort((a: any, b: any) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime())[0];
      if (firstSession) {
        this.event.next_date = firstSession.start_date;
      }
    }

    // horarios disponibles (solo sesiones activas, para el flujo de compra).
    // Se cuelan también las sesiones ya empezadas que el fin de ventas todavía
    // permite vender, o el botón dejaría entrar y el selector estaría vacío.
    this.sessionsEnabled = this.event.sessions.filter(session => session.active !== false && (
      this.eventosService.isSessionSaleExtended(this.event, session) ||
      (new Date(session.start_date) >= now && (!session.end_date || session.end_date && (new Date(session.end_date) >= now)))
    ));
    this.sessionsEnabled = this.sessionsEnabled.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());

    // Si el evento ya ha finalizado no quedan sesiones futuras que mostrar como horario;
    // en ese caso mostramos la hora de la última sesión pasada en vez de dejarlo en blanco.
    // Si tampoco hay sesiones pasadas caemos en la fecha del propio evento.
    const lastSession = [...this.event.sessions]
      .sort((a: any, b: any) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime())
      .slice(0, 1);
    const fallbackHours = lastSession.length > 0
      ? lastSession
      : (this.event?.start_date ? [{ start_date: this.event.start_date }] : []);
    const sessionsForHours = this.sessionsEnabled.length > 0
      ? this.sessionsEnabled
      : fallbackHours;

    // ORDENAR LAS HORAS USANDO UTC (getUTCHours y getUTCMinutes)
    this.optionsHour = sessionsForHours.sort((a: any, b: any) => {
      const dateA = new Date(a.start_date);
      const dateB = new Date(b.start_date);
      return (dateA.getUTCHours() * 60 + dateA.getUTCMinutes()) - (dateB.getUTCHours() * 60 + dateB.getUTCMinutes());
    });
    
    // Coger las horas únicas USANDO UTC, para que no se repitan
    this.optionsHour = this.optionsHour.filter((session: any, index: number, self: any[]) =>
      index === self.findIndex((s: any) => (
        new Date(s.start_date).getUTCHours() === new Date(session.start_date).getUTCHours() &&
        new Date(s.start_date).getUTCMinutes() === new Date(session.start_date).getUTCMinutes()
      ))
    );

    // LÓGICA PARA REVISAR SI TODAS LAS FECHAS TIENEN LOS MISMOS HORARIOS
    const hoursByDate = new Map<string, string[]>();
    
    this.sessionsEnabled.forEach((session: any) => {
      const d = new Date(session.start_date);
      // Extraemos la fecha y la hora en formato UTC para evitar saltos de zona
      const dateKey = `${d.getUTCFullYear()}-${d.getUTCMonth()}-${d.getUTCDate()}`;
      const timeKey = `${d.getUTCHours().toString().padStart(2, '0')}:${d.getUTCMinutes().toString().padStart(2, '0')}`;
      
      if (!hoursByDate.has(dateKey)) {
        hoursByDate.set(dateKey, []);
      }
      if (!hoursByDate.get(dateKey)!.includes(timeKey)) {
        hoursByDate.get(dateKey)!.push(timeKey);
      }
    });
    this.sameHoursForAllDates = true;
    let referenceHours: string[] = [];
    let isFirst = true;

    for (let hoursArray of hoursByDate.values()) {
      hoursArray.sort(); // Ordenamos las horas de ese día de menor a mayor
      if (isFirst) {
        referenceHours = hoursArray;
        isFirst = false;
      } else {
        // Comparamos si este día tiene exactamente las mismas horas que el día de referencia
        if (JSON.stringify(referenceHours) !== JSON.stringify(hoursArray)) {
          this.sameHoursForAllDates = false;
          break; // Si un solo día es diferente, rompemos el ciclo y ocultamos las horas
        }
      }
    }

    // No estará activa la venta si el evento ha terminado (solo en base a fechas, sin considerar active).
    // Con una sesión empezada que el fin de ventas aún permite vender, no.
    const sessionsWithFutureDates = this.event.sessions.filter((session: any) => new Date(session.start_date) >= now);
    if (sessionsWithFutureDates?.length <= 0 && !this.eventosService.hasSessionSaleExtended(this.event)) {
      this.endedEvent = true;
      this.enableAbono = false;
    }

    // Comprobar si el evento ha terminado
    if (this.event?.end_sales) {
      this.endSales = (new Date(this.event?.end_sales) <= nowHour);
      this.enableAbono = this.enableAbono ? !this.endSales : false;
    }

    if(this.pastEvent) {
      this.endedEvent = true;
      this.enableAbono = false;
    }

    this.startSalesCountdown();

    this.markBuyBar(this.hasActions);
  }

  /**
   * Con la venta aún cerrada, la ficha cuenta cuánto queda para que abra y
   * suelta el botón ella sola al llegar a cero, sin recargar. El objetivo es
   * el mismo instante con el que se calcula disabledSales, para que el reloj
   * no pueda decir una cosa y el botón otra.
   */
  private startSalesCountdown(): void {
    if (!this.disabledSales || this.endedEvent || this.endSales || this.pastEvent) {
      return;
    }
    this.salesOpenDate = new Date(this.event.start_sales);
    this.buildOpenLabels(this.salesOpenDate);
    this.countdownSubscription = this.salesCountdown.countdownTo(this.event.start_sales)
      .subscribe(countdown => {
        this.countdown = countdown;
        if (!countdown) {
          this.disabledSales = false;
          this.salesOpenDate = null;
        }
      });
  }

  /**
   * El cuándo va como dato debajo de su etiqueta, no como frase: «Vie 12 oct ·
   * 10:00». Es la misma cadena en la ficha y en la barra de móvil, así que no
   * hay dos versiones que mantener.
   *
   * Con la apertura a la vuelta de la esquina el día de la semana no dice
   * nada: lo que se entiende es «hoy» o «mañana».
   */
  private buildOpenLabels(date: Date): void {
    const hour = formatDate(date, 'HH:mm', this.locale);
    const day = formatDate(date, 'yyyyMMdd', this.locale);
    const today = formatDate(new Date(), 'yyyyMMdd', this.locale);
    const tomorrow = formatDate(new Date(Date.now() + 86400000), 'yyyyMMdd', this.locale);

    if (day === today || day === tomorrow) {
      this.salesOpenLabel = `${day === today ? 'Hoy' : 'Mañana'} · ${hour}`;
      return;
    }
    // 'EEE d MMM' en es-ES da «vie 12 oct»; en mayúscula inicial es un dato y
    // no un trozo de frase
    const when = formatDate(date, 'EEE d MMM', this.locale).replace('.', '');
    this.salesOpenLabel = `${when.charAt(0).toUpperCase()}${when.slice(1)} · ${hour}`;
  }


  ngOnDestroy(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
    this.markBuyBar(false);
  }

  /**
   * La barra va fija al viewport, así que se le pone encima al pie: el pie
   * es hermano del router-outlet y no hay forma de que la barra lo empuje.
   * Marcando el body, el pie se reserva el hueco él mismo (ver su SCSS).
   */
  private markBuyBar(visible: boolean): void {
    const method = visible ? 'addClass' : 'removeClass';
    this.renderer[method](document.body, 'has-buy-bar');
  }

  checkEventHasAbono() {
    const eventId = this.event?.id;
    if (!eventId) { this.enableAbono = false; return; }
    this.bondsService.getPassesByEvent(eventId).subscribe({
      next: (res) => {
        // Un abono que ya no se puede completar no cuenta: su botón no llevaría a ningún sitio
        const passes = (res?.passes || []).filter((p: any) => !passUnavailableMessage(p));
        if (passes.length > 0 && !this.endedEvent && !this.endSales) {
          this.enableAbono = true;
        }
      },
      error: () => { this.enableAbono = false; }
    });
  }

  buyAbono() {
    // Comprobar si es un evento privado
    if (this.event.private_event) {
      const refAbonosDialog = this.dialog.open(PrivateEventComponent, {
        panelClass: ['info-dialog', 'not-padding', 'info-abono-dialog'],
      });
      refAbonosDialog.afterClosed().subscribe({
        next: (result) => {
          if (result) {
            this.eventosService.checkCodePrivateEvent(this.event.id, result).subscribe({
              next: (data: any) => {
                if (data.success) {
                  this.openDialogBond();
                } else {
                  this.openErrorDialog('Lo sentimos, el código es incorrecto.');
                }
              }, error: (err) => {
                this.openErrorDialog('Lo sentimos, el código es incorrecto.');
              }
            });
          }
        }
      })
    } else {
      this.openDialogBond();
    }
  }

  openErrorDialog(message: string) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: message,
        btnCancel: false
      }
    });
  }

  // Componente para entradas de tipo festival
  openTicketsBond() {
    let bondTicket = this.event?.entradas.find((value) => value.typeBond);
    const refAbonosDialog = this.dialog.open(TicketsBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: { ticket: bondTicket, eventId: this.event.id, eventName: this.event.title }
    });
    refAbonosDialog.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          this.router.navigate(['/cart-checkout']);
        }
      }
    })
  }

  openDialogBond() {
    const eventId = this.event?.id;
    this.bondsService.getPassesByEvent(eventId).subscribe({
      next: (res) => {
        const passes = (res?.passes || []).filter((p: any) => !passUnavailableMessage(p));
        if (passes.length === 0) {
          this.openErrorDialog('No hay abonos disponibles para este evento en este momento.');
          return;
        }
        const dialogRef = this.dialog.open(PassSelectDialogComponent, {
          panelClass: ['info-dialog', 'pass-select-dialog-panel'],
          data: { passes }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          if (result?.pass) {
            this.dialog.open(PassPurchaseComponent, {
              panelClass: ['info-dialog', 'not-padding', 'pass-purchase-dialog-panel'],
              width: '860px',
              maxWidth: '95vw',
              data: { passId: result.pass.id, quantity: result.quantity || 1, fromEventId: eventId }
            });
          }
        });
      },
      error: () => {
        this.openErrorDialog('Error al cargar los abonos disponibles.');
      }
    });
  }

  goToScrollPage(idPage: string) {
    var height = document.getElementById(idPage).offsetTop - 30;
    window.scrollTo(0, height);
  }

  openEvent(url: string) {
    if (this.event.external) {
      window.open(url, '_blank');
    } else {
      if (this.sessionsEnabled?.length <= 0) {
        this.openErrorDialog('Este evento no tiene sesiones activas disponibles en este momento.');
        return;
      }
      // Comprobar si es un evento privado
      if (this.event.private_event) {
        const refAbonosDialog = this.dialog.open(PrivateEventComponent, {
          panelClass: ['info-dialog', 'not-padding', 'info-abono-dialog'],
        });
        refAbonosDialog.afterClosed().subscribe({
          next: (result) => {
            if (result) {
              this.eventosService.checkCodePrivateEvent(this.event.id, result).subscribe({
                next: (data: any) => {
                  if (data.success) {
                    this.startPurchase();
                  } else {
                    this.openErrorDialog('Lo sentimos, el código es incorrecto.');
                  }
                }, error: (err) => {
                  this.openErrorDialog('Lo sentimos, el código es incorrecto.');
                }
              });
            }
          }
        })
      } else {
        this.startPurchase();
      }
    }
  }

  /**
   * El mapa es por sesión. Con una única sesión a la venta no hay nada que
   * elegir en el calendario, así que se va directo al mapa; con varias (o sin
   * mapa, donde la entrada se elige en el propio panel) primero el calendario.
   */
  private startPurchase() {
    const singleSessionMap = !!this.event?.map_version && !!this.event?.space && this.sessionsEnabled.length === 1;
    if (singleSessionMap) {
      this.openMap.emit(this.sessionsEnabled[0]);
    } else {
      this.openHours.emit(true);
    }
  }

  convertDateToStringFormat(date: Date, format: string) {
    return (this.eventosService.ConvertDateToStringFormat(date, format));
  }

}
